import React from "react";
import { useNavigate } from "react-router-dom";

function WelcomeComponent() {
    const navigate = useNavigate();

    return (
        <div style={styles.container}>
            <h1 style={styles.heading}>Welcome!</h1>
            <div style={styles.buttonContainer}>
                <button
                    style={styles.button}
                    onClick={() => {
                        const baseUrl = process.env.REACT_APP_WEB_BASE_URL;
                        if (baseUrl) {
                            window.location.href = baseUrl; 
                        } else {
                            console.error("Base URL is not defined in environment variables.");
                        }
                    }}
                >
                    Go to Website
                </button>
                <button style={styles.button} onClick={() => navigate("/admin")}>
                    Go to Admin
                </button>
                <button style={styles.button} onClick={() => navigate("/doctor")}>
                    Go to Doctor
                </button>
                <button style={styles.button} onClick={() => navigate("/center")}>
                    Go to Center
                </button>
            </div>
        </div>
    );
}

const styles = {
    container: {
        textAlign: "center",
        padding: "50px",
    },
    heading: {
        fontSize: "2.5rem",
        marginBottom: "40px",
    },
    buttonContainer: {
        display: "flex",
        justifyContent: "center",
        gap: "20px",
    },
    button: {
        padding: "12px 24px",
        fontSize: "16px",
        cursor: "pointer",
    },
};

export default WelcomeComponent;
